import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { HEADER } from 'utils/sectionTypes';
import { BUILDER } from 'shared/abilities';
import { section } from '../decorators';
import style from './SimpleHeader.scss';

const propTypes = {
  children: PropTypes.node.isRequired,
  isBuilderView: PropTypes.bool,
};
const SimpleHeader = ({ children }) => {
  const [logo, headerText, navigation] = React.Children.toArray(children);

  return (
    <div className={style.root}>
      <div className="container">
        <div className={style.imageContainer}>
          {React.cloneElement(logo, { className: style.image })}
        </div>
        <div className={cx(style.headerText, 'simple-nav-header')}>
          {headerText}
        </div>
      </div>
      {React.cloneElement(navigation)}
    </div>
  );
};

SimpleHeader.propTypes = propTypes;

const component = section(
  { name: 'Header: Navbar', region: HEADER, category: 'Header / Navigation' },
  {
    subsections: [
      { accepts: ['HeaderLogo'] },
      { accepts: ['Button', 'HeaderText'] },
      { accepts: ['Navigation'] },
    ],
    defaults: [
      'HeaderLogo',
      'HeaderText',
      'Navigation',
    ],
    hideLabel: true,
  },
)(SimpleHeader);

component.authorization = { action: 'manage', subject: BUILDER };

export default component;
